/**
 * @file 反馈表单
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback} from 'react';
import {Button, Col, Form, Input, Row} from 'antd';
import classNames from 'classnames';
import {FormInstance, FormProps} from 'antd/es/form';

export interface IFeedbackFormProps {
    form: FormInstance;
    verifyCodeImg: string;
    verifyCodeLoading: boolean;
    getVerifyCode?: () => void;
    submit?: (fieldValue: { [field: string]: any }) => void;
}

const FeedbackForm: React.FC<IFeedbackFormProps> = (props) => {
    const {
        getVerifyCode,
        verifyCodeLoading,
        verifyCodeImg,
        form,
        submit
    } = props;

    const handleOnFinish = useCallback<Exclude<FormProps['onFinish'], undefined>>(
        (values) => {
            submit && submit(values);
        },
        [submit]
    );

    return (
        <div className="paddle-feedback-form">
            <Form
                hideRequiredMark
                layout="vertical"
                form={form}
                colon={false}
                onFinish={handleOnFinish}
            >
                <Row gutter={65} className="paddle-feedback-form-inner">
                    <Col lg={12}>
                        <Form.Item
                            label="问题与建议"
                            className="paddle-feedback-form-item-problems"
                            name="problems"
                            rules={[{required: true, message: '请输入问题'}]}
                            initialValue={'您的反馈与建议在飞桨官方qq群（703252161）里可以得到更快速的回复哦~'}
                        >
                            <Input.TextArea
                                className="paddle-feedback-form-item-problems-input"
                                placeholder="您的任何问题与建议"
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={12}>
                        <Form.Item
                            label="姓名"
                            name="name"
                            rules={[{required: true, message: '请输入姓名'}]}
                        >
                            <Input
                                className="paddle-feedback-form-item-input"
                                placeholder="请输入姓名"
                            />
                        </Form.Item>
                        <Form.Item
                            label="联系方式"
                            name="phoneNumber"
                            rules={[
                                {required: true, message: '请输入手机号'},
                                {pattern: /^1\d{10,}$/, message: '请输入正确的手机号'}
                            ]}
                        >
                            <Input
                                className="paddle-feedback-form-item-input"
                                placeholder="请输入联系方式"
                            />
                        </Form.Item>
                        <Form.Item
                            label="验证码"
                            className="paddle-feedback-form-item-code-item"
                        >
                            <div className="paddle-feedback-form-item-code-wrap">
                                <Form.Item
                                    className="paddle-feedback-form-item-code-input-wrap"
                                    name="verifyCode"
                                    rules={[{required: true, message: '请输入验证码'}]}
                                >
                                    <Input
                                        className="paddle-feedback-form-item-input"
                                        placeholder="请输入验证码"
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <div className="paddle-feedback-form-item-code-img-wrap">
                                        <img
                                            alt="验证码"
                                            className="paddle-feedback-form-item-code-img"
                                            src={verifyCodeImg}
                                        />
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <i
                                        className={classNames(
                                            'paddle-feedback-form-item-code-reload',
                                            verifyCodeLoading && 'paddle-feedback-form-item-code-reloading'
                                        )}
                                        onClick={getVerifyCode}
                                    />
                                </Form.Item>
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
                <Row className="paddle-feedback-form-item-submit-btn-group">
                    <Col xs={24}>
                        <Button
                            type="primary"
                            size="large"
                            className="paddle-feedback-form-item-submit-btn"
                            htmlType="submit"
                        >
                            提交
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default FeedbackForm;
